import {
  Component,
  ElementRef,
  HostListener,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { OrganizationService } from '../../../../modules/settings/location/services/organization.service';
import { BreadcrumbService } from '../../../../shared/service/breadcrumb.service';
import { SharedDataService } from '../../../../shared/service/shared-data/shared-data.service';
import { NotificationModalComponent } from '../notification-modal/notification-modal.component';
import { Router } from '@angular/router';
import { TokenService } from '../../../../shared/service/token.service';
import { UserOrgService } from 'src/app/shared/service/user-org.service';
import { NotificationDetailService } from 'src/app/modules/settings/user-notification/service/notification-detail.service';
import { UserLocationService } from 'src/app/shared/service/user-location.service';
import { ManageProfileService } from 'src/app/modules/settings/manage-profile/manage-profile.service';
import { EnvironmentService } from 'src/app/shared/environment.service';
import { PlanningDataService } from 'src/app/shared/service/planning-data.service';
import { PlanningHeaderData } from 'src/app/shared/service/planning-header-data';
import { LOCAL_STORAGE_KEYS } from 'src/app/constants/roles-permissions.constants';
import { PermissionsService } from 'src/app/services/permissions.service';
import { PERMISSIONS } from 'src/app/constants/permissions.constants';
import { filter, Subject, Subscription, take, takeUntil } from 'rxjs';
import { DepartmentService } from 'src/app/modules/settings/location/services/department.service';
import { DutiesService } from 'src/app/modules/settings/duties/services/duties.service';
import { OneSignalPushService } from 'src/app/services/one-signal-push.service';
import { getAvatarColour, getInitials } from 'src/app/shared/utils/avatar.util';
export interface MenuItem {
  outlinedIcon: string;
  filledIcon: string;
  height: number;
  label: string;
  routerLink: string;
  requiredPermissions?: string[]; // optional
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  notificationIcon: string = 'icon-notification';
  iconWidth: string = '24';
  iconHeight: string = '24';
  iconViewBox: string = '0 0 24 24';
  filterForm: any;
  noOrganizationLogo:string = 'assets/image/no-org-logo.webp';
  getInitials = getInitials;
  getAvatarColour = getAvatarColour;
  languages = [
    { id: 'de', viewValue: 'DE' },
    { id: 'en', viewValue: 'EN' },
  ];
  menuItems = [
    {
      outlinedIcon: 'icon-home',
      filledIcon: 'icon-home_active',
      height: 24,
      label: 'Dashboard',
      routerLink: '/dashboard',
    },
    {
      outlinedIcon: 'icon-planning-sheet',
      filledIcon: 'icon-planning-sheet_active',
      height: 24,
      label: 'Planning Sheets',
      routerLink: '/planning-sheet',
      requiredPermissions: [
        PERMISSIONS.PLANNING_SHEET_WRITE,
        PERMISSIONS.PLANNING_SHEET_READ,
      ],
    },
    {
      outlinedIcon: 'icon-staff',
      filledIcon: 'icon-staff_active',
      height: 24,
      label: 'Staff',
      routerLink: '/staff/staffs',
      requiredPermissions: [
        PERMISSIONS.GLOBAL_STAFF_BASIC_INFORMATION_WRITE,
        PERMISSIONS.GLOBAL_STAFF_BASIC_INFORMATION_READ,
        PERMISSIONS.GLOBAL_STAFF_CONFIGURATION_DETAILS_WRITE,
        PERMISSIONS.GLOBAL_STAFF_CONFIGURATION_DETAILS_READ,
        PERMISSIONS.GLOBAL_STAFF_EMPLOYMENT_DETAILS_WRITE,
        PERMISSIONS.GLOBAL_STAFF_EMPLOYMENT_DETAILS_READ,
      ],
    },
    {
      outlinedIcon: 'icon-qr-code',
      filledIcon: 'icon-qr-code_active',
      height: 24,
      label: 'Staff QR Code',
      routerLink: '/staff/staff-qr-code',
      requiredPermissions: [
        PERMISSIONS.GLOBAL_STAFF_BASIC_INFORMATION_WRITE,
        PERMISSIONS.GLOBAL_STAFF_BASIC_INFORMATION_READ,
        PERMISSIONS.GLOBAL_STAFF_CONFIGURATION_DETAILS_WRITE,
        PERMISSIONS.GLOBAL_STAFF_CONFIGURATION_DETAILS_READ,
        PERMISSIONS.GLOBAL_STAFF_EMPLOYMENT_DETAILS_WRITE,
        PERMISSIONS.GLOBAL_STAFF_EMPLOYMENT_DETAILS_READ,
      ],
    },
    {
      outlinedIcon: 'icon-attendance-reg',
      filledIcon: 'icon-attendance-reg_active',
      height: 24,
      label: 'Attendance Register',
      routerLink: '/staff/staff-log-dashboard',
      requiredPermissions: [
        PERMISSIONS.GLOBAL_STAFF_BASIC_INFORMATION_WRITE,
        PERMISSIONS.GLOBAL_STAFF_BASIC_INFORMATION_READ,
        PERMISSIONS.GLOBAL_STAFF_CONFIGURATION_DETAILS_WRITE,
        PERMISSIONS.GLOBAL_STAFF_CONFIGURATION_DETAILS_READ,
        PERMISSIONS.GLOBAL_STAFF_EMPLOYMENT_DETAILS_WRITE,
        PERMISSIONS.GLOBAL_STAFF_EMPLOYMENT_DETAILS_READ,
      ],
    },
    {
      outlinedIcon: 'icon-stream',
      filledIcon: 'icon-stream_active',
      height: 24,
      label: 'Stream',
      routerLink: '/streams',
      requiredPermissions: [//show stream icon only if user has at least one of these permissions.
        PERMISSIONS.STREAM_MANAGEMENT_READ,
        PERMISSIONS.STREAM_MANAGEMENT_WRITE,
      ],
    },
    {
      outlinedIcon: 'icon-chat',
      filledIcon: 'icon-chat_active',
      height: 24,
      label: 'Chat',
      routerLink: '/chat',
      requiredPermissions: [
        PERMISSIONS.CHAT_CONFIGURATION_READ,
        PERMISSIONS.CHAT_CONFIGURATION_WRITE,
      ],
    },
    {
      outlinedIcon: 'icon-configuration',
      filledIcon: 'icon-configuration_active',
      height: 24,
      label: 'Configuration',
      routerLink: '/configuration',
    },
  ];

  @ViewChild('dropdownContainer', { static: false })
  dropdownContainer!: ElementRef;
  @ViewChild(NotificationModalComponent)
  notificationModal!: NotificationModalComponent;

  locationControl = new FormControl();
  storedLocationId =
    typeof window !== 'undefined' && window.sessionStorage
      ? sessionStorage.getItem('userLocationId')
      : null;

  subMenuItems = [
    {
      label: 'Location Details',
      routerLink: '/locations',
      location: 'location',
      requiredPermissions: [
        PERMISSIONS.LOCATION_DETAILS_READ,
        PERMISSIONS.LOCATION_DETAILS_WRITE,
      ],
    },
    {
      label: 'Shift/ Duties',
      routerLink: '/duties',
      location: 'duties',
      requiredPermissions: [
        PERMISSIONS.DUTY_MANAGEMENT_READ,
        PERMISSIONS.DUTY_MANAGEMENT_WRITE,
        PERMISSIONS.DUTY_PLANNING_ACTIVATION_READ,
        PERMISSIONS.DUTY_PLANNING_ACTIVATION_WRITE,
        PERMISSIONS.DUTY_DEPARTMENT_MAPPING_READ,
        PERMISSIONS.DUTY_DEPARTMENT_MAPPING_WRITE,
      ],
    },
    {
      label: 'Holidays',
      routerLink: '/holidays',
      location: 'holidays',
      requiredPermissions: [
        PERMISSIONS.HOLIDAY_DETAILS_READ,
        PERMISSIONS.HOLIDAY_DETAILS_WRITE,
      ],
    },
    {
      label: 'Staff/ Team',
      routerLink: '/staff',
      location: 'staff',
      requiredPermissions: [
        PERMISSIONS.STAFF_BASIC_INFORMATION_WRITE,
        PERMISSIONS.STAFF_BASIC_INFORMATION_READ,
        PERMISSIONS.STAFF_CONFIGURATION_DETAILS_WRITE,
        PERMISSIONS.STAFF_CONFIGURATION_DETAILS_READ,
        PERMISSIONS.STAFF_EMPLOYMENT_DETAILS_WRITE,
        PERMISSIONS.STAFF_EMPLOYMENT_DETAILS_READ
      ],
    },
    {
      label: 'Events',
      routerLink: '/events',
      location: 'indicators',
      requiredPermissions: [
        PERMISSIONS.EVENT_DETAILS_WRITE,
        PERMISSIONS.EVENT_DETAILS_READ,
      ],
    },
    {
      label: 'Activities',
      routerLink: '/activities',
      location: 'activities',
      requiredPermissions: [
        PERMISSIONS.ACTIVITY_DETAILS_WRITE,
        PERMISSIONS.ACTIVITY_DETAILS_READ,
      ],
    },
  ];
  private justOpenedDropdown: boolean = false;
  menuItemLength: number = 0;
  selLangInLocStg = typeof window !== 'undefined' && window.localStorage ? localStorage.getItem('locale') : this.languages[0].id;
  selectedLanguage = this.selLangInLocStg;
  isHighlighted: boolean = false;
  breadcrumbs: { label: string; url?: string }[] = [];
  selectedMenu: any = [{ label: 'Home', url: '/' }];
  activeNotificationIcon: string = 'icon-notification_active';
  locations: { locationId: string; locationName: string }[] = [];
  profileImg: string;
  loggedInUser: boolean = false;
  callApi: boolean = true;
  filteredMenuItems: MenuItem[] = []; // Holds the filtered list
  orgDetails: any;
  orgLogo: string | null;
  selectedLocation: { locationId: string; locationName: string; } | undefined;
  planFormSubmitted:boolean = true
  isLoadingMenu: boolean = true;
  private destroy$ = new Subject<void>();
  isLogoReady = false;
  unreadChatCount = 0;
  private chatroomListSubscription?: Subscription;
  private isChatroomSubscriptionInitializing = false;
  private notificationSubscription?: Subscription;
  private isNotificationSubscriptionInitializing = false;
  private unreadChatRoomCounts = new Map<string, number>();
  userName: string = '';
  constructor(
    private _formBuilder: FormBuilder,
    private breadcrumbService: BreadcrumbService,
    public sharedDataService: SharedDataService,
    public orgService: OrganizationService,
    public router: Router,
    public _tokenService: TokenService,
    private _userOrganisation: UserOrgService,
    private _userNotifications: NotificationDetailService,
    private _userLocations: UserLocationService,
    public _manageProfile: ManageProfileService,
    public envService: EnvironmentService,
    private planningDataService: PlanningDataService,
    private planningHeaderData: PlanningHeaderData,
    private permissionsService: PermissionsService,
    private _departmentService: DepartmentService,
    private _dutiesService: DutiesService,
    private oneSignalPushService: OneSignalPushService,
    private injector: Injector
  ) {}

  ngOnInit() {
   this.sharedDataService.planFormSubmitted$.subscribe({
     next: (data) => {
      this.planFormSubmitted = data
      //check whether the logout request is from planning sheet
      if(this.router.url.startsWith('/planning-sheet') && this.planningDataService.getSelRouterLink() === '/login'){
      this.logoutProcess()
      }
     },
     error:(err) => {}
  })
    this.sharedDataService.locale$.subscribe(locale => {
    this.selLangInLocStg = locale;
    this.selectedLanguage = this.selLangInLocStg
    this.sharedDataService.setLanguage(this.selectedLanguage);
    this.filterForm = this._formBuilder.group({
      searchData: [''],
      language: [this.selectedLanguage],
    });
  });
    this.permissionsService.userPermissions$
      .pipe(
        takeUntil(this.destroy$),
        filter((permissions) => permissions && permissions.length > 0) // skip empty/initial emissions
      ).subscribe((permissions) => {
      this.filterMenuItems(permissions);
    });
    if (typeof window !== 'undefined') {
      const currentUrl = window.location.pathname; // Only the base path
      //to highlight the icon on initial load after login.
      this.sharedDataService.activeTab = currentUrl;
      this._tokenService.getLoginStatusObservable().
      pipe(filter(isLoggedIn => !!isLoggedIn),take(1)).
      subscribe(() => {
            this.initializeData();
            this.loggedInUser = true;
            this.sharedDataService.userLoggedIn = true;
            this.getStaffData();
            this.initializeChatUnreadIndicator();
            this.subscribeToNotificationUpdates();
      });
    }
    this.menuItemLength = this.menuItems.length;
    this.filterForm = this._formBuilder.group({
      searchData: [''],
      language: [this.selectedLanguage],
    });
    this.breadcrumbService.breadcrumbs$.subscribe((breadcrumbs) => {
      this.breadcrumbs = breadcrumbs;
    });
    if(this.sharedDataService.activeTab === '/help-and-support'){
      this.sharedDataService.activeTab = 'help-and-support'
    }
  }

  get selLocationName(): string | null {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    return sessionStorage.getItem('selLocationName');
  }
  return null;
}

  getOrganisationData() {
    this.orgService.fetchOrganization().subscribe({
      next: (orgData: any) => {
        if (orgData.status === 200) {
          this.sharedDataService.setOrgDetails(orgData.body);
          this.sharedDataService.setOrgLogo(`${this.envService.imgReviewUrl}/${orgData.body.logo_url}`);
        }
      },
    });
  }

  filterMenuItems(currentPermissions: string[]): void {
    this.isLoadingMenu = true; // start loader
    // Get current location's permissions
      const userRole = this.permissionsService.getUserRole(); // Assume it returns a string like 'ADMIN', 'STAFF', etc.

    this.filteredMenuItems = this.menuItems.filter((item) => {
      if (item.label === 'Staff QR Code') {
        if (!this._tokenService.isStemplingEnabled()) {
          return false;
        }
      }
      if (item.label === 'Timesheet') {
        // Same gating as the old staff timesheet button:
        // APP_ADMIN / ORG_ADMIN / DEP_ADMIN and stempling enabled.
        return (
          (userRole === 'APP_ADMIN' ||
            userRole === 'ORG_ADMIN' ||
            userRole === 'DEP_ADMIN') &&
          this._tokenService.isStemplingEnabled()
        );
      }
      if (item.label === 'Configuration') {
        // Show configuration icon, if user is not STAFF or POOL
        const isElevatedUser = userRole !== 'STAFF' && userRole !== 'POOL';
        return isElevatedUser;
      }
      if (!item.requiredPermissions) return true; // No permission check needed
      return item.requiredPermissions.some((permission) =>
        currentPermissions.includes(permission)
      );
    });
    // stop loader after filtering
    setTimeout(() => {
      this.isLoadingMenu = false;
    }, 500);
  }

  getStaffData() {
     this.sharedDataService.staffProfile$
      .pipe(takeUntil(this.destroy$), filter(data => !!data))
      .subscribe((profile: any) => {
        this.userName = profile?.name || this.userName;
      });

     this.sharedDataService.orgDetails$.subscribe(data => {
      if (data) {
        this.orgDetails = data;
      } else {
        this.getOrganisationData(); // Call API if no data
      }
    });

    this.sharedDataService.orgLogo$.subscribe(logo => {
      if (logo) {
        this.orgLogo = logo;
        this.isLogoReady = true; 
      } 
    });
    this.sharedDataService.loginUserImg$.subscribe((profile) => {
      if (profile) {
          // this.sharedDataService.userName = profile?.name;        
          this.profileImg = profile;
      }
      else {
        // this.profileImg = 'assets/image/no-profile.webp';
      }
    });
    if (this.loggedInUser && sessionStorage.getItem('LOGIN')) {
        this.sharedDataService.loadStaffProfile();
        this.sharedDataService.staffProfile$
          .pipe(filter(data => !!data), take(1))
          .subscribe((profile: any) => {
            this.userName = profile?.name || '';
          });
        this.sharedDataService.loginUserImg$
        .pipe(filter(data => !!data), take(1))
        .subscribe((profile: any) => {
          // this.sharedDataService.userName = profile?.name;        
          this.profileImg = profile;
        });
    } else {
      this.profileImg = 'assets/image/no-profile.webp';
    }
  }


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.justOpenedDropdown) {
      this.justOpenedDropdown = false; // Reset the flag after the first click
      return; // Skip the check to avoid blinking
    }

    const targetElement = event.target as HTMLElement;

    // Check if the dropdown is shown
    if (this.sharedDataService.showDropDown && this.dropdownContainer) {
      const isClickInsideDropdown =
        this.dropdownContainer.nativeElement.contains(targetElement);

      if (!isClickInsideDropdown) {
        this.sharedDataService.showDropDown = false;
      }
    }
  }

  loadNotifications() {
    const params = {
      page: 0,
      size: 10,
    };

    this._userNotifications.fetchAllNotifications(params).subscribe({
      next: (response: any) => {
        if (response?.body?.content?.length > 0) {
          this.sharedDataService.unreadNotfCount = response?.body?.content[0]?.unReadNotificationCount || 0;
        } else {
          this.sharedDataService.unreadNotfCount = 0;
        }
      },
      error: (error: any) => {
        console.error(error);
      },
    });
  }

  showNotificationsDialog() {
    if (this.sharedDataService.unreadNotfCount === 0) {
      this.router.navigate(['/notification-detail']);
      this.planningDataService.setSelRouterLink('/notification-detail');
      this.sharedDataService.activeTab = '/notification-detail';
      this.breadcrumbService.updateBreadcrumbs([
        { label: 'Home', url: '/dashboard' },
        { label: 'Notifications', url: '/notification-detail' },
      ]);
    } else {
      this.notificationModal.toggleModal();
      this.planningDataService.setSelRouterLink('/notification-detail') //store url of the tab that the user clicked in local storage
      if (this.notificationModal.showModal) {
        this.notificationIcon = 'icon-notification_active';
      } else {
        this.notificationIcon = 'icon-notification';
      }
    }
  }

  onNotificationModalClosed() {
    this.notificationIcon = 'icon-notification';
  }

  initializeData() {
    this.locations = this._userLocations.getLocationData();
    this.setLocationToUser();
  }

  initializeChatUnreadIndicator() {
    this.subscribeToChatroomUpdates();
  }

  async subscribeToChatroomUpdates(): Promise<void> {
    if (this.chatroomListSubscription || this.isChatroomSubscriptionInitializing) {
      return;
    }

    const userId = this._userOrganisation.getUserId() ?? sessionStorage.getItem('orgUser');
    if (!userId) {
      return;
    }

    this.isChatroomSubscriptionInitializing = true;

    try {
      (globalThis as any).global = (globalThis as any).global ?? globalThis;
      const { RxStompService } = await import('src/app/shared/stomp/rx-stomp.service');
      const rxStompService = this.injector.get(RxStompService);

      this.chatroomListSubscription = rxStompService
        .watch(`/queue/chatroom-list/${userId}`)
        .subscribe((message) => {
          if (!message.body) {
            return;
          }

          try {
            const updatedRoom = JSON.parse(message.body);
            const roomId = updatedRoom?.roomID ?? updatedRoom?.roomId;
            this.updateUnreadChatRoomCount(roomId, updatedRoom?.numberOfUnread ?? 0);
          } catch (error) {
            console.error('Failed to process chatroom websocket update', error);
          }
        });
    } catch (error) {
      console.error('Failed to initialize chat websocket unread indicator', error);
    } finally {
      this.isChatroomSubscriptionInitializing = false;
    }
  }

  async subscribeToNotificationUpdates(): Promise<void> {
    if (this.notificationSubscription || this.isNotificationSubscriptionInitializing) {
      return;
    }

    const staffId = this._userOrganisation.getUserId() ?? sessionStorage.getItem('orgUser');
    if (!staffId) {
      return;
    }

    this.isNotificationSubscriptionInitializing = true;

    try {
      (globalThis as any).global = (globalThis as any).global ?? globalThis;
      const { RxStompService } = await import('src/app/shared/stomp/rx-stomp.service');
      const rxStompService = this.injector.get(RxStompService);

      this.notificationSubscription = rxStompService
        .watch(`/queue/unread/${staffId}`)
        .subscribe((message) => {
          if (!message.body) {
            return;
          }

          try {
            let count: number | null = null;
            try {
              const data = JSON.parse(message.body);
              if (typeof data === 'number') {
                count = data;
              } else if (data && typeof data.unreadCount === 'number') {
                count = data.unreadCount;
              } else if (data && typeof data.count === 'number') {
                count = data.count;
              } else if (data && typeof data.unreadNotfCount === 'number') {
                count = data.unreadNotfCount;
              } else if (data && typeof data.unReadNotificationCount === 'number') {
                count = data.unReadNotificationCount;
              }
            } catch (e) {
              const num = Number(message.body);
              if (!isNaN(num)) {
                count = num;
              }
            }
            if (count !== null) {
              this.sharedDataService.unreadNotfCount = count;
            }
          } catch (error) {
            console.error('Failed to process notification websocket update', error);
          }
        });
    } catch (error) {
      console.error('Failed to initialize notification websocket unread indicator', error);
    } finally {
      this.isNotificationSubscriptionInitializing = false;
    }
  }

  updateUnreadChatRoomCount(roomId: string | null | undefined, count: number): void {
    if (!roomId) {
      return;
    }

    const normalizedCount = Math.max(0, Number(count) || 0);
    if (normalizedCount === 0) {
      this.unreadChatRoomCounts.delete(roomId);
    } else {
      this.unreadChatRoomCounts.set(roomId, normalizedCount);
    }

    this.unreadChatCount = Array.from(this.unreadChatRoomCounts.values()).reduce(
      (total, unreadCount) => total + unreadCount,
      0
    );
  }

  setLocationToUser() {
    if (this.locations) {
      // Check if locationId exists in the list
      this.selectedLocation = this.locations.find(
        (location) => location.locationId === this.storedLocationId
      );

      // Set the FormControl value based on the stored userLocationId, or default to the first location
      if (this.selectedLocation) {
        this.locationControl.setValue(this.selectedLocation);
      } else {
        // Default to the first element if no valid userLocationId is found
        this.locationControl.setValue(this.locations[0]);
      }
    }
  }
  
  onLocationChange(event: any) {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const selectedLocation = event.value;
      sessionStorage.setItem('userLocationId', selectedLocation.locationId);
    }
  }

  onMenuOpened(): void {
    this.isHighlighted = true;
  }

  onMenuClosed(): void {
    this.isHighlighted = false;
  }

  // onSearchClick() {
  //   this.sharedDataService.toggleSearchSidebar();
  // }

  onSelectMenuItem(menuItem: any) {
    this.sharedDataService.selRouterLink = menuItem.routerLink; // Store selected route
    this.planningDataService.setSelRouterLink(menuItem.routerLink) // Store selected route in local storage
    // the following condition is to check whether the user tries to navigate to any other pages after making changes to organization edit form
    // if have no unsaved changes then navigate ,logic is added to wait for confirmation to update the breadcrumb-so that it updates only after confirming the option
    if (this.sharedDataService.hasUnsavedOrgChanges) {
      this.sharedDataService.showWarningMessageDialog().then((confirmed) => {
        if (confirmed) {
          this.sharedDataService.hasUnsavedOrgChanges = false;
          this.navigateToMenuItem(menuItem);
        }
      });
    } else {
      this.navigateToMenuItem(menuItem);
    }
  }

  showHelpAndSupport(navDtls:any){
    this.sharedDataService.activeTab = navDtls.routerLink;
    this.planningDataService.setSelRouterLink('/help-and-support') //store url of the tab that the user clicked in local storage
    this.router.navigateByUrl(navDtls.routerLink);
  }

  private navigateToMenuItem(menuItem: any) {
    if (menuItem.label === 'Configuration') {
      this.sharedDataService.showDropDown =
        !this.sharedDataService.showDropDown;
      this.justOpenedDropdown = this.sharedDataService.showDropDown; // Set the flag when opening
    } else {
      this.selectedMenu = [{ label: 'Home', url: '/' }];
      this.sharedDataService.activeTab = menuItem.routerLink;
      this.sharedDataService.showDropDown = false;
      this.selectedMenu.push({
        label: menuItem.label,
        url: menuItem.routerLink,
      });
      // Update breadcrumb only after confirmation
      this.breadcrumbService.updateBreadcrumbs(this.selectedMenu);
    }
  }

  onBreadcrumbClick(breadcrumb: { label: string; url: string }) {
    this.breadcrumbService.trimBreadcrumbs(breadcrumb.label);
  }

  onLangChange(event: any) {
    this.selectedLanguage = event.value;
    this.sharedDataService.setLanguage(this.selectedLanguage);
    this.sharedDataService.setLocale(event.value);
  }

  logout() {
    this.router.navigateByUrl('/');
    this.planningDataService.setSelRouterLink('/login')
    this.logoutProcess()
  }

  logoutProcess(){
    if(this.planFormSubmitted){
      this.callApi = true;
      this._tokenService.removeToken();
      this._tokenService.removeRefreshToken();
      this._tokenService.removeStemplingEnabled();
      this._tokenService.removeRedirectUrl();
      this._tokenService.removeLogin();
      this._userOrganisation.clearOrgId();
      this._userOrganisation.clearUserId();
      this._userOrganisation.clearOneSignalUserId();
      this.oneSignalPushService.logout();
      this._userLocations.clearSelLocationId()
      this._userLocations.clearSelLocationName()
      this.planningDataService.clearPlanningData();
      this.planningDataService.clearApiToCallData();
      this.sharedDataService.curMonInMonPicker=new Date();//reset the month picker current value to current month, so as to prevent the previous selection from being chosen
      this._departmentService.clearbaseDeptId()
      this.planningDataService.clearSelRouterLink()
      this.sharedDataService.clearPlanFormSubmitted()
      this.sharedDataService.selDeptInPlanning = null
      this.sharedDataService.selDateInPlanning = new Date()
      this.sharedDataService.clearLoginUserImg()
      this.unreadChatRoomCounts.clear();
      this.unreadChatCount = 0;
      this.sharedDataService.unreadNotfCount = 0;
      if (this.notificationSubscription) {
        this.notificationSubscription.unsubscribe();
        this.notificationSubscription = undefined;
      }
      this._dutiesService.clearSelectedDutyViewInLocal()
      this.sharedDataService.staffProfileSubject.next(null);
      this.planningDataService.resetCanPrePlanData();
      this.profileImg = '';
       this.userName = '';
      this.orgDetails = null;
      this.orgLogo = null;
      this.filteredMenuItems=[];//to prevent previous menu values showing after logout
      // Capture locale before clearing
      const locale = localStorage.getItem('locale');
      // Clear all storages
      localStorage.clear();
      sessionStorage.clear();
      // Restore locale if it existed
      if (locale) {
      localStorage.setItem('locale', locale);
      }
      this.permissionsService.clearState();
      this.permissionsService.resetBasePermissionsCache();//remove the base permissions cache
      // Clear PlanningHeaderData values
      this.planningHeaderData.selectedMonth = null;
      this.planningHeaderData.selectedYear = null;
      this.router.navigateByUrl('/');
      this._tokenService.setRedirectUrl('/login');
    }
  }

    get hasProfileImage(): boolean {
    return !!this.profileImg
      && !this.profileImg.includes('no-profile')
      && !this.profileImg.includes('default-avatar');
  }

  manageProfile() {
    this.selectedMenu = [];
    this.selectedMenu.push(
      { label: 'Home', url: '/' },
      { label: 'Manage Profile', url: '/manage-profile' }
    );
    this.planningDataService.setSelRouterLink('/manage-profile')
    this.breadcrumbService.updateBreadcrumbs(this.selectedMenu);
  }
  ngOnDestroy(): void {
    if (this.chatroomListSubscription) {
      this.chatroomListSubscription.unsubscribe();
      this.chatroomListSubscription = undefined;
    }
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
      this.notificationSubscription = undefined;
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
